import apiClient from 'apiClient/index';

export function uploadImg(testId: string, imgfile: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    apiClient.user.generateImageToken(testId)
      .then((resp) => {
        if (resp && resp.data) {
          const imgToken = resp.data;
          apiClient.user
            .uploadProfileImg(
              imgToken.groupId,
              imgToken.imageId,
              imgfile.type.split('/')[1],
              imgToken.token,
              imgfile,
            )
            .then((uploadResp) => {
              resolve(imgToken.imageId);
            })
            .catch((err) => reject(err));
        }
      })
      .catch((err) => reject(err));
  });
}
